<script lang="ts">
  import type { Channel } from '../firebase/api/channel';
  import type { FeedAbstract } from '../firebase/common/feed';
  import type { Plan } from '../firebase/common/plan';
  import FeedAbstractCard from './FeedAbstractCard.svelte';

  export let owner: boolean = false;
  export let channel: Channel;
  export let feeds: FeedAbstract[];
  export let plans: Plan[];
  export let currentPlan: Plan | null;
  export let currentCID: string | null = null;
</script>

<div class="feeds">
  {#each feeds as feed}
    {@const requiredPlan =
      feed.minimum_plan === 0
        ? null
        : plans.sort((a, b) => a.price - b.price).find((plan) => plan.price >= feed.minimum_plan) ?? null}
    <FeedAbstractCard {owner} {channel} {feed} {requiredPlan} {currentPlan} {currentCID} />
  {/each}
</div>

<style lang="scss">
</style>
